import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { formatFormPhone } from 'assets/utils/forms/formatFormPhone';
import { isEmail, isValidPhoneNumber } from 'assets/utils/parsersAndValidation/Validators';
import { values } from 'lodash';
import ContractConsentRequestType from 'models/enums/ContractConsentRequestType';
import { useContractConsentProvider } from '../ContractConsent.Hooks';

export type ContractResendConsentForm = Api.Core.ContractConsent.Resend.IParams &
  Api.Core.ContractConsent.Resend.IRequest;
export default function ContractConsentResendConsent() {
  const { lang } = getLocales();
  const { selected, pageRouter, isEnabled, resendConsent } = useContractConsentProvider();

  if (!isEnabled(selected)) {
    pageRouter.updateParams({});
    return null;
  }

  return (
    <ModalForm<ContractResendConsentForm>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.resendConsent}
      default={{
        id: selected?.id,
        requestType: selected?.type ?? ContractConsentRequestType.EMAIL,
        customerEmail: selected?.customerEmail,
        customerPhoneNumber: selected?.customerPhoneNumber ?? selected?.contract?.client?.phone,
      }}
      onCancel={() => pageRouter.updateParams({})}
      onSubmit={async ({ id, requestType, customerEmail, customerPhoneNumber }) => {
        await resendConsent({ id, requestType, customerEmail, customerPhoneNumber });
      }}
      validation={(data, errors) => {
        if (!data.requestType) errors.requestType = lang.required;
        if (!data.customerEmail && data.requestType === ContractConsentRequestType.EMAIL)
          errors.customerEmail = lang.required;
        if (!data.customerPhoneNumber && data.requestType === ContractConsentRequestType.TEXT)
          errors.customerPhoneNumber = lang.required;
        if (data.customerEmail && !isEmail(data.customerEmail)) errors.customerEmail = lang.invalidEmailFormatRequires;
        if (data.customerPhoneNumber && !isValidPhoneNumber(data.customerPhoneNumber))
          errors.customerPhoneNumber = lang.invalidFormatRequires.replace('{format}', '###-###-####');
      }}
      render={({ form }) => (
        <FormWrapper>
          <SelectInput
            name="requestType"
            data={values(ContractConsentRequestType).map((it) => ({
              id: it,
              title: it.toUpperCase(),
            }))}
            value={form.data?.requestType}
            onChange={form.update}
            error={form.errors.requestType}
            label={lang.type}
            icon={<Icon class="fas-envelope" />}
          />
          <TextInput
            name="data"
            label={form.data.requestType === ContractConsentRequestType.EMAIL ? lang.email : lang.phoneNumber}
            value={
              form.data.requestType === ContractConsentRequestType.EMAIL
                ? form.data?.customerEmail
                : form.data?.customerPhoneNumber
            }
            error={
              form.data.requestType === ContractConsentRequestType.EMAIL
                ? form.errors?.customerEmail
                : form.errors?.customerPhoneNumber
            }
            onChange={({ data }) =>
              form.data.requestType === ContractConsentRequestType.EMAIL
                ? form.update({ customerEmail: data })
                : form.update({ customerPhoneNumber: formatFormPhone(form.data.customerPhoneNumber, data) })
            }
            icon={<Icon class="if-quill-pen" />}
          />
        </FormWrapper>
      )}
    />
  );
}
